/* eslint-disable indent */
import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';
import { IconifiedList } from '@zillow/zrs-comet';

import ConnectedModuleCard from '../ConnectedModuleCard';

export const StyledConnectedModuleCard = styled(ConnectedModuleCard)`
  ${mediaMixin(
    'lg',
    css`
      min-height: 510px;
    `,
  )}
`;

export const StyledIconifiedList = styled(IconifiedList)`
  /** 
  * There is an issue where text-overflow ellipsis does not work within flexbox
  * set direct 
  * suggestion was to add min-width to the parent flext item of the text element
  * that wasn't the exact solution for this, but applying that to 
  * the following classes worked.
  * 
  * ref: https://www.phind.com/search?cache=450991ba-a52f-4287-8e18-24bbde838398
  */
  [class^='IconifiedList__Items'] {
    min-width: 0;
  }

  [class*='IconifiedList-ItemContent'] {
    min-width: 0;
  }
`;
